module.exports = __webpack_public_path__ + "img/teamtip_new_season-en-600x200.58ce143f.png";